<template>
	<!-- eslint-disable -->
	<svg fill="#ffffff" version="1.1" viewBox="0 0 41.114 35.957">
		<g transform="translate(-132.51 -92.143)">
			<path
				d="m148.58 127.74c-0.51419-0.29948-0.61736-0.88004-0.61736-3.4738 0-2.0617 0.1491-3.238 0.44115-3.4804 0.25631-0.21271 3.1132-0.41559 6.818-0.48417 6.2356-0.11543 6.4085-0.13901 7.8064-1.0649 1.6052-1.0632 2.9262-3.3985 2.9262-5.1731 0-1.4956-0.86974-3.5219-2.0329-4.7363-1.5189-1.5858-3.7127-2.0202-10.202-2.0202h-5.7568v3.4572c0 3.4668-0.2628 4.3039-1.3512 4.3039-0.27752 0-3.5892-2.4708-7.3593-5.4908-4.7268-3.7863-6.8202-5.6754-6.7435-6.0854 0.15946-0.85263 13.348-11.342 14.27-11.349 1.0276-0.0079 1.1843 0.57529 1.1843 4.4077v3.2974l15.012 0.22659 2.4486 1.2064c8.9394 4.4042 10.953 15.326 4.1246 22.371-1.9845 2.0474-4.8198 3.5626-7.6431 4.0845-2.6137 0.48316-12.496 0.4853-13.324 3e-3z"
				stroke-width=".35278"
			/>
		</g>
	</svg>
</template>
